import React from "react";
import { LoadingAnimation } from "@texada/ui";
import "./LoadingScreen.scss";

interface LoadingScreenProps {
  isLoading: boolean;
  refresh?: boolean;
  fullScreen?: boolean;
  isCollapse?: boolean;
  isCardLoading?: boolean;
}

export const LoadingScreen = (props: LoadingScreenProps) => {
  if (props.isLoading && props.refresh === false) {
    return (
      <div
        className={`loading_screen ${props.fullScreen ? "fullScreen" : ""} ${
          props.isCollapse ? "collapsed " : ""
        } ${props.isCardLoading ? "rental-loading" : ""}`}
      >
        <LoadingAnimation delay={1000} />
      </div>
    );
  }
  return <></>;
};

LoadingScreen.defaultProps = {
  refresh: false
};

export default LoadingScreen;
